import { render, staticRenderFns } from "./EspecificacaoProdutoList.vue?vue&type=template&id=461d67d9"
import script from "./EspecificacaoProdutoList.vue?vue&type=script&lang=js"
export * from "./EspecificacaoProdutoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports